import { useCallback, useEffect, useRef } from "react";

/*
 * Creates a callable function which always calls the latest version of the `event` parameter.
 * @param event The event function.
 * @returns The proxy function.
 */
export function useEvent<T extends (...args: any[]) => any>(event: T | undefined | null): T {
    const eventRef = useRef(event);

    useEffect(() => {
        eventRef.current = event;
    }, [event]);
    
    return useCallback((...args: Parameters<T>): ReturnType<T> => {
        return eventRef.current?.(...args);
    }, []) as unknown as T;
}